import { Pipe, PipeTransform } from '@angular/core';
import { Claims } from '@core/authentication/claims';
import * as _ from 'lodash';
import { CountryComponentRegistryService } from '../services';

@Pipe({
  name: 'enableForCountries'
})
export class EnableForCountriesPipe implements PipeTransform {
  constructor(
    protected readonly countryService: CountryComponentRegistryService
  ) {}

  transform<T>(countries: `${Claims.Country}` | `${Claims.Country}`[]): boolean {
    if (this.isArray(countries)) {
      return countries.includes(this.countryService.getCountry());
    }
    return countries === this.countryService.getCountry();
  }

  private isArray(
    countries: `${Claims.Country}` | `${Claims.Country}`[]
  ): countries is `${Claims.Country}`[] {
    return _.isArray(countries);
  }
}
